import React from 'react';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import history from '../../history';
import anime from 'animejs'
import { withLocalize } from "react-localize-redux";

import {InputText,InputPassword } from '../input/InputText.tsx'

import SvgLogin from './SvgLogin';

import { LOGOUT_USER } from '../../actions/types'
import { loginUser, logoutUser, resetMessage } from '../../actions/auth'

class Login extends React.Component {

  constructor(props) {
      super(props);
      this.domainName = window.location.hostname;
      this.navigatorLanguage = window.navigator.language ? window.navigator.language.slice(0,2) : "en";
      if (this.domainName === "aegiscertogether.com") {
          this.props.setActiveLanguage("en");
      } else if (localStorage.getItem("ikos-language")) {
          this.props.setActiveLanguage(localStorage.getItem("ikos-language"));
      } else if (["fr", "es", "de", "it"].includes(this.navigatorLanguage)) {
          this.props.setActiveLanguage(this.navigatorLanguage);
      } else  {
      }

      this.state = {
          fields: 2,
          form: {
              email: { value: "" },
              password: { value: "" }
          },
          message: null
      };
      this.login = this.login.bind(this);
  }

  UNSAFE_componentWillUnmount() {
    this.props.resetMessage();
  }

  componentDidMount() {


    anime({
      targets: '#ImgGreyShape',
      scale: {
        value: [0.3, 0.9],
        duration: 600,
      },
      easing: 'easeOutQuad'
    });

    anime({
      targets: '#imgCharacter',
      scale: {
        value: [0, 0.9],
        duration: 600,
        delay: 300
      },
      easing: 'easeOutQuad'
    });

    anime({
      targets: '#imgFlower',
      scale: {
        value: [0, 0.9],
        duration: 800,
        delay: 300
      },
      easing: 'easeOutQuad'
    });

      anime({
          targets: "#aegis-logo",
          scale: {
              value: [0, 0.9],
              duration: 600,
              delay: 600
          },
          easing: 'easeOutQuad'
      });
  }

  UNSAFE_componentWillMount() {
    if (this.props.authenticated) this.props.logoutUser('', LOGOUT_USER)
  }


  UNSAFE_componentWillReceiveProps(NextProps) {
    var route;

    if (!this.props.authenticated && NextProps.authenticated) {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user.role === "Admin" || user.role === "SuperAdmin") {
        route = "/user"
      }else  if (user.role === "DirectorGeneral" || user.role === "AssociateDirector"){
        route = "/dashboard/"
      }else  if (user.role === "BusinessUnitManager" || user.role === "Manager" || user.role === "BusinessDeveloper"){
        route = "/manager/" + user._id
      } else {
        route = "/consultant/" + user.consultant._id

      }
      history.push(route)
    }
    if (NextProps.message !== this.state.message) {
      this.setState({ message: NextProps.message })
    }
  }



  handleInputTextChange(obj, bool){
    
    var form = Object.assign({},this.state.form);
    
    form[obj.target.name] = {value : obj.target.value, isValid : obj.target.value !== "" ? true : false};
    this.setState({form : form})

    if(this.state.message !== ""){
      this.setState({message : ""})
    }

  }

  handleEmailChange(obj, bool){
    
    const regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    var form = Object.assign({},this.state.form);
    
    form[obj.target.name] = {value : obj.target.value, isValid : regexEmail.test(obj.target.value)};
    this.setState({form : form})

    if(this.state.message !== ""){
      this.setState({message : ""})
    }

  }



  login(e) {

    e.preventDefault();
    var form = Object.assign({}, this.state.form);
    var fields = 0;

    for (let property in form) {
      if (form[property].isValid) {
        fields++
      } 
    }

    if (fields === this.state.fields) {
      var obj = {}
      for (let property in form) {
        obj[property] = form[property].value
      }
      this.props.loginUser(obj);
    } else {
      this.setState({ message: "Le formulaire n'est pas correctement rempli" })
    }

  }

  render() {

    return (
      <div className="login">
        <div className="col-2">
          <h1>{this.props.translate("login.Connexion.title")}</h1>
          <p>
            {this.props.translate("login.Prompt-invite.title")}
          </p>
          <div className="form-container">
            {this.state.message !== '' ?
              <p className="warning">{this.props.translate("login.errorMessage.title")}</p> : null
            }
            <form onSubmit={(e) => this.login(e)}>
              <div className="form-auth" >
                <div>
                  <span className="icon"><i className="fas fa-user"></i></span>
                  <InputText 
                    onChange={this.handleEmailChange.bind(this)}
                    value={this.state.form.email.value}
                    name={'email'}
                    isRequired={true}
                    placeholder={this.props.translate("login.Enter-email.title")} 
                    label={{title : this.props.translate("login.Adresse email.title")}}
                  />
                </div>
                <div><span className="icon"><i className="fas fa-key"></i></span>
                <InputPassword
                  onChange={this.handleInputTextChange.bind(this)}
                  value={this.state.form.password.value}
                  name={'password'}
                  isRequired={false}
                  placeholder={this.props.translate("login.Enter-password.title")} 
                  label={{title : this.props.translate("login.Mot de passe.title")}}
                />
              </div>
              </div>

              <div style={{ width: "85%" }}><Link to="forgot-password" style={{ float: "right" }}>{this.props.translate("login.Forgot-password.title")}</Link></div>

              <button type="submit" className="primary-btn" >{this.props.translate("login.Connexion.title")}</button>
              <Link to="/forgot-password"><button className="secondary-btn">{this.props.translate("login.Not-subscribe-yet.title")}</button></Link>
            </form>
          </div>
        </div>
        <div className="col-2 flex">
                <SvgLogin />
                {this.domainName === "aegiscertogether.com" ? 
                    <img
                        className="aegis-logo-big animated"
                        alt="Aegis Logo"
                        src="https://aegiscertification.com/wp-content/uploads/2023/03/cropped-ACE-Logo-1-1.png"
                    /> : 
                    <img
                        className="ikos-logo-big animated"
                        alt="IKOS Logo"
                        src="https://www.nuclearvalley.com/media/cache/resolve/medium/entreprises/logos/16636_47cab734d6e161e0d9cdfc7cf6a89830.png"
                    />
                }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
  message: state.auth.message,
  userId: state.auth.id,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  loginUser,
  logoutUser,
  resetMessage
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(Login));
